import { Card, Collapsible, Heading, Layout } from '@components'
import { AppCollapsible } from '@components'
import { when } from '@core'
import { useService } from 'solid-services'
import { useAuth } from '@state'
import { Show } from 'solid-js'
import { Box, Grid } from 'styled-system/jsx'
import Channels from '../Chat/Channels'
import ChannelSetups from '../Chat/Setups'
import Column from './Column'
import Setups from './Setups'
import TradeLeaders from './TradeLeaders'
import { Filter } from './Setups/Filter'

const Desktop = () => (
	<Layout
		gap={3}
		p={0}
		gridTemplateColumns="2fr 5fr 2fr"
		pt={'12px'}
	>
		<Column
			title="Trade Leaders"
			link="/chat/trade-leaders"
		>
			<TradeLeaders />
		</Column>
		<Column
			title="Setups"
			link="/setups"
			rightSlot={<Filter/>}
		>
			<Setups />
		</Column>
		<Grid alignContent="start">
			<Column
				title="Chats"
				link="/chat"
			>
				<Card.Root p="2">
					<Channels
						isMinimal
						height="auto"
					/>
				</Card.Root>
			</Column>
			<Column title="Recently Commented Setups">
				<Card.Root p="2">
					<ChannelSetups
						isMinimal
						height="auto"
					/>
				</Card.Root>
			</Column>
			<Column title="Next Webinar">
				<Card.Root p="2">
					<p>Crypto fnds</p>
				</Card.Root>
			</Column>
		</Grid>
	</Layout>
)

const Mobile = () => (
	<Layout
		gap={3}
		p={0}
		pt={'50px'}
	>
		<Card.Root p={2}>
			<AppCollapsible headerContent={<Heading size="lg">Trade Leaders</Heading>}>
				<TradeLeaders />
			</AppCollapsible>
		</Card.Root>
		<Card.Root p={2}>
			<AppCollapsible headerContent={<Heading size="lg">Chats</Heading>}>
				<Channels height="calc(50vh)" />
			</AppCollapsible>
		</Card.Root>
		<Card.Root p={2}>
			<AppCollapsible headerContent={<Heading size="lg">Recently Commented</Heading>}>
				<ChannelSetups height="calc(50vh)" />
			</AppCollapsible>
		</Card.Root>
	</Layout>
)

export default function () {
	const { isOnboarded } = useService(useAuth)()

	return (
		<Show
			when={when.mdDown()}
			fallback={<Desktop />}
		>
			<Mobile />
		</Show>
	)
}

// {/* <TradeLeaders />
// <Setups />
// <Chats /> */}
// {/* <Flex
// 	justifyContent="space-between"
// 	gap={4}
// 	alignItems={{ base: 'center', smDown: 'stretch' }}
// 	flexDirection={{ base: 'row', smDown: 'column' }}
// >
// 	<Welcome />
// 	<FranicsUpdates username="fred" />
// </Flex>
// <Grid
// 	height={{
// 		base: 'calc(100vh - 246px)',
// 		mdDown: 'auto',
// 	}}
// 	gridTemplateColumns={{
// 		base: '1fr 1fr',
// 		mdDown: '1fr',
// 	}}
// >
// 	<Show
// 		when={isOnboarded()}
// 		fallback={<Onboarding />}
// 	>
// 		<Setups />
// 		<Chats />
// 	</Show>
// </Grid> */}
